import React from "react";

import PlacementTeamHeader from "./PlacementTeamHeader";

import { PlacementTeamProps } from "../types/placement";

import { selectSetting } from "../../../../../features/global/globalSlice";
import { useAppSelector } from "../../../../../hooks/reduxHooks";

const PlacementTeam = ({
    team,
    ratings,
    setRatings,
}: PlacementTeamProps): React.JSX.Element => {
    const questions = useAppSelector(state =>
        selectSetting(state, "majorybl_resume_questions"),
    );

    return (
        <section
            className="placementTeam"
            id={`team${team.id}`}
            data-testid="placementTeam"
        >
            <PlacementTeamHeader
                team={team}
                ratings={ratings}
                setRatings={setRatings}
            />
            {questions?.setting.map((q: { id: number; question: string }) => (
                <div
                    key={`${team.id}-question${q.id}`}
                    data-testid={`${team.id}-question${q.id}`}
                >
                    <div className="question">
                        <h6>Question #{q.id}</h6>
                        <h6>{q.question}</h6>
                    </div>
                    <div className="answer">
                        {team.resume &&
                            team.resume.find(r => r.question === q.id)?.answer}
                    </div>
                </div>
            ))}
        </section>
    );
};

export default PlacementTeam;
